


















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'Cloumns',
  props: {
    cloumns: {
      type: Array,
      defalut: []
    },
    labelWidth: {
      type: String,
      defalut: '120'
    },
    cloumnBtn: {
      type: String,
      default: null
    }
  },
  setup(prop: any, { emit }) {
    const handleBtnClick = (): void => {
      emit('handleBtnClick');
    };

    return  {
      handleBtnClick
    };
  },
});
